import { useState } from 'react';

import { useAuth } from '../../../auth/AuthProvider.jsx';
import { PageHeader } from '../../../components/ui/PageHeader.jsx';
import { Tabs } from '../../../components/ui/Tabs.jsx';
import { Card } from '../../../components/ui/Card.jsx';

import { ConfigTab } from './ConfigTab.jsx';
import { RulesTab } from './RulesTab.jsx';
import { TemplatesTab } from './TemplatesTab.jsx';
import { LogsTab } from './LogsTab.jsx';

const TABS = [
  { value: 'config', label: 'Configurazione' },
  { value: 'rules', label: 'Eventi e regole' },
  { value: 'templates', label: 'Template' },
  { value: 'logs', label: 'Log invii' }
];

export function NotificationsPage() {
  const { hasPermission } = useAuth();
  const canRead = hasPermission('notifications:read');
  const canManage = hasPermission('notifications:manage');
  const [tab, setTab] = useState('config');

  if (!canRead) {
    return (
      <div className="flex flex-col gap-6">
        <PageHeader title="Notifiche" />
        <Card><p className="text-sm text-ink-muted">Nessun permesso di accesso alle notifiche.</p></Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Notifiche" description="Invio email: provider, configurazione, quali eventi notificare e a chi, e i template." />
      <Tabs value={tab} onChange={setTab} items={TABS} />
      {tab === 'config' && <ConfigTab canManage={canManage} />}
      {tab === 'rules' && <RulesTab canManage={canManage} />}
      {tab === 'templates' && <TemplatesTab canManage={canManage} />}
      {tab === 'logs' && <LogsTab />}
    </div>
  );
}
